import React from "react"
import Model from "./model"

import "./header.css"
import "./style.css"

import image1 from "../../../../static/images/images/logo.svg"
export default function Header() {
  return (
    <>
      <header className="header">
        <div className="other-header">
          <div className="container">
            <div className="other-header-inner">
              <Model />
              <div className="other-header-nav">
                <div className="img-wrapper mx-auto">
                  <span className="navbar-brand">
                    <img alt="" className="img-fluid" src={image1} />
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </header>
    </>
  )
}
